import Droppable from "../DnD/Droppable";
import "./CanvasBuilder.scss";
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";
import SortableItem from "../DnD/SortableItem";
import Button from "../../../components/Button/Button";
import Icon, {secondEditIcon} from "../../../components/Icon/Icon";
import SingleArea from "../Elements/Droppable/Area/Area";
import Checkbox from "../Elements/Droppable/Input/Checkbox";
import Date from "../Elements/Droppable/Input/Date";
import LongText from "../Elements/Droppable/Input/LongText";
import Number from "../Elements/Droppable/Input/Number";
import Radio from "../Elements/Droppable/Input/Radio";
import Select from "../Elements/Droppable/Input/Select";
import Signature from "../Elements/Droppable/Input/Signature";
import String from "../Elements/Droppable/Input/String";
import Area from "../Elements/Droppable/Area/Area";
import Text from "../../Public/Elements/Text/Text"

const CanvasBuilder = ({rootItems, setEditItem, droppedItems}) => {
    const elementTypes = {
        "area": SingleArea,
        "checkbox": Checkbox,
        "date": Date,
        "long": LongText,
        "number": Number,
        "radio": Radio,
        "select": Select,
        "signature": Signature,
        "string": String,
        "text": Text
    };

    let childrenItems = [];
    let itemIds = [];
    let counter = 0;

    return(
        <div className="canvas-builder">
            <Droppable id="main-droppable">
                {rootItems.length === 0 ? (
                    <p className="info">Drag an area type to start creating your new form</p>
                ) : (
                    <SortableContext items={rootItems.map(i => i?.id)} strategy={verticalListSortingStrategy}>
                        {rootItems.map(item => {
                            if (!item) return null;

                            if(counter === 0){
                                itemIds = [];
                                childrenItems = [];
                            }

                            const areaType = item.settings.areaType.split("-")[1];
                            const childItems = droppedItems.filter(child => child?.parentId === item.id);

                            itemIds.push(item.id);
                            childrenItems.push(childItems);

                            if ((areaType === "double" && counter === 0) || (areaType === "triple" && counter === 2)){
                                counter = 1;
                                return;
                            }else if(areaType === "triple" && counter === 0) {
                                counter = 2;
                                return;
                            }

                            counter = 0;

                            return (
                                <SortableItem key={item.id} id={item.id}>
                                    <div className="item">
                                        <Area
                                            itemIds={itemIds}
                                            settings={item.settings}
                                            childrenItems={childrenItems}
                                            elementTypes={elementTypes}
                                            setEditItemId={(itemId) => setEditItem(droppedItems.find(i => i.id === itemId))}
                                        />
                                        <Button variant="action" onClick={() => setEditItem(droppedItems.find(i => i.id === item.id))}>
                                            <Icon svg={secondEditIcon} className="builder"/>
                                        </Button>
                                    </div>
                                </SortableItem>
                            );
                        })}
                    </SortableContext>
                )}
            </Droppable>
        </div>
    )
}

export default CanvasBuilder;